export const isABTastyVariation = (variationName = '') => {
  const variationBlock = document.getElementById(variationName);

  return variationBlock && variationBlock.className.includes('show-test');
};
